import React from 'react';

const useStaticContentTemplate = () => {
	React.useEffect(() => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	}, []);
};

export default useStaticContentTemplate;
